// Centralized route registry — never write route strings manually in components

export const ROUTES = {
  root:       '/',
  home:       '/home',
  login:      '/login',
  admin:      '/admin',
  departments: '/departments',
  scan:       '/scan',
  department: (slug: string) => `/departments/${slug}`,
  departmentPattern: '/departments/:departmentSlug',
  document:   (id: string)   => `/documents/${id}`,
  documentPattern: '/documents/:documentId',
  qr:         (token: string) => `/q/${encodeURIComponent(token)}`,
  qrPattern:  '/q/:token',
  notFound:   '/404',
  unauthorized: '/unauthorized',
} as const;

export type AppRoute = typeof ROUTES;
